// extracted by mini-css-extract-plugin
module.exports = {"form":"form__1xlBO","form__item":"form__item__EqR0x","avatar":"avatar__tBnkd"};